export const FeedbackType = {
  /** This made me pause and think in a way I hadn't before */
  THOUGHT_PROVOKING: "tp",
  /** I had no idea about this or this completely changed how I see this topic */
  EYE_OPENING: "eo",
  /** I can actually use this in my life/work or this gives me concrete steps to take */
  PRACTICAL: "pr",
  /** This was genuinely interesting or I want to know more about this topic */
  INTRIGUING: "in",
} as const;

export type FeedbackType = (typeof FeedbackType)[keyof typeof FeedbackType];

export const ReportReason = {
  SPAM: "spam",
  HARASSMENT: "harassment",
  MISINFORMATION: "misinformation",
  INAPPROPRIATE: "inappropriate",
  COPYRIGHT: "copyright",
  /** Requires an explanation */
  OTHER: "other",
} as const;

export type ReportReason = (typeof ReportReason)[keyof typeof ReportReason];

export const FEEDBACK_TYPES: FeedbackType[] = Object.values(FeedbackType);
export const REPORT_REASONS: ReportReason[] = Object.values(ReportReason);

const FEEDBACK_LABELS: Record<FeedbackType, string> = {
  [FeedbackType.THOUGHT_PROVOKING]: "Thought-provoking",
  [FeedbackType.EYE_OPENING]: "Eye-opening",
  [FeedbackType.PRACTICAL]: "Practical",
  [FeedbackType.INTRIGUING]: "Intriguing",
};

const FEEDBACK_DESCRIPTIONS: Record<FeedbackType, string> = {
  [FeedbackType.THOUGHT_PROVOKING]: "This made me pause and think in a way I hadn't before",
  [FeedbackType.EYE_OPENING]: "I had no idea about this or this completely changed how I see this topic",
  [FeedbackType.PRACTICAL]: "I can actually use this in my life/work or this gives me concrete steps to take",
  [FeedbackType.INTRIGUING]: "This was genuinely interesting or I want to know more about this topic",
};

const REPORT_REASON_LABELS: Record<ReportReason, string> = {
  [ReportReason.SPAM]: "Spam",
  [ReportReason.HARASSMENT]: "Harassment",
  [ReportReason.MISINFORMATION]: "Misinformation",
  [ReportReason.INAPPROPRIATE]: "Inappropriate content",
  [ReportReason.COPYRIGHT]: "Copyright violation",
  [ReportReason.OTHER]: "Other",
};

export const getFeedbackLabel = (type: FeedbackType): string => FEEDBACK_LABELS[type];

export const getFeedbackDescription = (type: FeedbackType): string => FEEDBACK_DESCRIPTIONS[type];

export const getReportReasonLabel = (reason: ReportReason): string => REPORT_REASON_LABELS[reason];

export const ContactMessageStatus = {
  PENDING: "pending",
  REPLIED: "replied",
  SPAM: "spam",
} as const;

export type ContactMessageStatus = (typeof ContactMessageStatus)[keyof typeof ContactMessageStatus];
